import { ManualTransferInitialState } from "../interface";

export const selectBlockNavigation = (state: any) =>
  state.manualTransfer.blockNavigation;

export const selectNotes = (state: any) => state.manualTransfer.notes;

export const selectAttachments = (state: any) =>
  state.manualTransfer.attachments;

export const selectPOItems = (state: any) => state.manualTransfer.poItems;

export const isResetSort = (state: any) => state.manualTransfer.resetSort;

export const selectCreatePOLoading = (state: any) =>
  state.manualTransfer.createPOLoading;

export const selectMargin = (state: any) => state.manualTransfer.margin;

export const selectTotalCost = (state: any) => state.manualTransfer.totalCost;

export const selectTotalExtendedCost = (state: any) =>
  state.manualTransfer.transfer;

export const selectMtPoItems = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) =>
  manualTransfer.poItems.map((item) => ({
    ...item,
    margin: item.margin + "%"
  }));

export const selectMtPoItemsCopy = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.poItemsCopy;

export const selectSearchQuery = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.searchQuery;

export const selectSearchResults = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.searchResults;

export const selectStoreList = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.storeList;

export const selectEditData = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.editData;

export const selectSearchProductsLoading = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.searchProductsLoading;

export const getReceiveStore = ({
  manualTransfer
}: {
  manualTransfer: ManualTransferInitialState;
}) => manualTransfer.purchasingOrganizationId;
